import { useState, useEffect } from "react";
import "./FormContentShort.css";
import { Question, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import { toastFail, toastSuccess } from "../../config";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectEditingForm, selectUIStates, setEditingForm } from "../../redux/features/appData";
import { useDispatch } from "react-redux";
import { SHORT_SETTINGS } from "../config/questionSettings";
import { DEBOUNCE_TIME } from "../config/forms";
import { apiFormHasEdits } from "../../services/FormService";

type FormContentShortProps = {
    question: Question;
    allowSaving?: boolean;
}

export const FormContentShort = ({question, allowSaving=true} : FormContentShortProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");

    const [ignoreDebouce, setIgnoreDebounce] = useState<boolean>(true);
    const [debouncedData, setDebouncedData] = useState<any | undefined>(undefined);
    const [settings, setSettings] = useState<any | undefined>(undefined);


    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
    }, [question])

    // Debounce settings changes
    useEffect(() => {
        if (settings && ignoreDebouce) {
            setIgnoreDebounce(false);
            return;
        }

        const handler = setTimeout(() => {
            if (!settings) {
                return;
            }
            setDebouncedData(settings);
        }, DEBOUNCE_TIME);

        // Clear the timeout if settings changes (i.e., user is still typing)
        return () => {
            clearTimeout(handler);
        };
    }, [settings]);

    // Effect to save the debounced data whenever it changes
    useEffect(() => {
        (async () => {
            if (!debouncedData) {
                return;
            }

            console.log("debouncedData: ", debouncedData);
            
            await handleSave();
        })()
    }, [debouncedData]);

    useEffect(() => {
        setSettings({
            title,
            description
        })
    }, [title, description])


    const updateRedux = () => {
        if (!editingForm) {
            return;
        }

        const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        if (index === -1) {
            toast("Can't find question id", toastFail);
            return;
        }

        const newQuestions = [...editingForm.questions];
        newQuestions[index] = {
            ...question,
            title,
            description
        };

        dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));
    }

    const handleSave = async () => {
        if (!editingForm || !allowSaving) {
            return;
        }

        // update question in redux first to avoid delay lag causing issues
        updateRedux();

        const settings = question.settings ? JSON.parse(question.settings) : SHORT_SETTINGS;

        const payload : UpdateQuestionPayload = {
            questionId: question.id,
            type: question.type,
            title: title,
            description: description,
            required: question.required,
            settings: JSON.stringify(settings),  // these don't change in this instance
            conditions: question.conditions
        }

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error saving update", toastFail);
            return;
        }

        await apiFormHasEdits(editingForm.id);
        console.log("Question updated");

 

        // const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        // if (index === -1) {
        //     toast("Can't find question id", toastFail);
        //     return;
        // }

        // const newQuestions = [...editingForm.questions];
        // newQuestions[index] = newQuestion;
        // dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));
    }

    return (
        
        <div className="form-content-body">
            <div className="form-content-title">
                <input 
                    type="text"
                    placeholder="..."
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    data-testid="question-title"
                />
                {/* {question.required && <span>*</span>} */}
            </div>
            <div className="form-content-description">
                <input 
                    type="text"
                    placeholder="Description (optional)"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    data-testid="question-description"
                />
            </div>   

            <div className="form-content-text">
                <input 
                    type="text"
                    placeholder="Your answer here..."
                    disabled={true}
                />
            </div>    

            {/* <button 
                onClick={handleSave}
                data-testid="save-question"
            >
                temp save button before debounce 
            </button> */}
        </div>
        
    )
}